export interface EditorData {
  html: string
  text: string
  revision: number
}

export const initialEditorData: EditorData = {
  html: '',
  text: '',
  revision: 0,
}

export function advanceEditorData(previous: EditorData, text: string): EditorData {
  return {
    ...previous,
    text,
    revision: previous.revision + 1,
  }
}
